export const FormattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
